// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"5e9c84ee","74":"d828b0dd","806":"234889e0"}[chunkId] + ".chunk.js";
};